import type { BaseSliceState } from '../../../../app/sliceUtils';
import { createInitialState } from '../../../../app/sliceUtils';
import type { VerificationView, EstimateEvaluationView } from '../index';

/**
 * Module-owned verification editing slice state — shared by every financial-clearance detail tab
 * (004 Detail, 005 Coverage, 006 Estimate, 008 Authorization). Extends the standard
 * `BaseSliceState<T>` (constitution §67): `current` / `isEdited` / `editedFields` /
 * `validationErrors`, plus a `server` backup for discard support. `current` holds the full editable
 * `VerificationView`; SAVE re-posts it verbatim so non-Coverage sections round-trip (spec 005).
 */
export interface VerificationSliceState extends BaseSliceState<VerificationView> {
  /** Last-known server state (a `structuredClone` of the loaded/saved case) — backs discard/revert. */
  server: VerificationView | null;
  /**
   * Transient, presentational result of `POST /verification/estimate/evaluate` (spec 006). Holds NO
   * rule codes/thresholds — only the server-returned matches/alerts/bypass. Never persisted.
   */
  evaluation: EstimateEvaluationView | null;
  /** Per-estimate "don't show code sets" suppression (FR-012). */
  disableCodeSetMatching: boolean;
}

export const initialState: VerificationSliceState = {
  ...createInitialState<VerificationView>(),
  server: null,
  evaluation: null,
  disableCodeSetMatching: false,
};
